var map = {
	"./default.png": 37,
	"./s-cta.png": 38,
	"./s-editor-media.png": 39,
	"./s-editor.png": 40,
	"./s-hero.png": 41,
	"./s-page-title.png": 42,
	"./s-quote.png": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;